/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 25 24" fill="none">
    <path d="M18.666 11.0859H14.666C14.4008 11.0859 14.1464 11.1913 13.9589 11.3788C13.7714 11.5664 13.666 11.8207 13.666 12.0859V17.0859C13.666 17.3512 13.7714 17.6055 13.9589 17.793C14.1464 17.9806 14.4008 18.0859 14.666 18.0859H18.666M6.66602 7.08594V20.0859C6.66602 20.6164 6.87673 21.1251 7.2518 21.5002C7.62687 21.8752 8.13558 22.0859 8.66602 22.0859H16.666C17.1964 22.0859 17.7052 21.8752 18.0802 21.5002C18.4553 21.1251 18.666 20.6164 18.666 20.0859V7.08594M5.66602 2.08594H19.666C20.2183 2.08594 20.666 2.53365 20.666 3.08594V6.08594C20.666 6.63822 20.2183 7.08594 19.666 7.08594H5.66602C5.11373 7.08594 4.66602 6.63822 4.66602 6.08594V3.08594C4.66602 2.53365 5.11373 2.08594 5.66602 2.08594Z" stroke="#262626" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgComponent;
